import { render, staticRenderFns } from "./VideoPresentationView.vue?vue&type=template&id=fddf4b86&"
import script from "./VideoPresentationView.vue?vue&type=script&lang=js&"
export * from "./VideoPresentationView.vue?vue&type=script&lang=js&"
import style0 from "./VideoPresentationView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports